import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-itdr-first-sync',
  standalone: true,
  imports: [],
  templateUrl: './itdr-first-sync.component.html',
  styleUrl: './itdr-first-sync.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItdrFirstSyncComponent {}
